var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6V11H17",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18V13H8",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28182 9.33263C4.74288 8.05833 5.52648 6.91902 6.55952 6.02102C7.59255 5.12302 8.84133 4.4956 10.1894 4.19729C11.5374 3.89898 12.9407 3.93952 14.2684 4.31511C15.596 4.69071 16.8048 5.38912 17.7818 6.34518L22 10.2218M2 13.7782L6.21818 17.6548C7.19523 18.6109 8.40398 19.3093 9.73165 19.6849C11.0593 20.0605 12.4626 20.101 13.8106 19.8027C15.1587 19.5044 16.4075 18.877 17.4405 17.979C18.4735 17.081 19.2571 15.9417 19.7182 14.6674",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.3f3977e69cdc195eabf22ea89a61ba61.svg";
export { ForwardRef as ReactComponent };